import React, {useMemo, useState} from "react";
import {useTranslate} from "../../../hooks/translate.hook";
import {SmartTable} from "../../common/smart-table/smart-table";
import {SmartTableDataHandler} from "../../common/smart-table/smart-table.data-handler";
import {Button, Space} from "antd";
import {declarationsDocumentsService} from "../../../services/declarations/declarations.documents.service";
import {columnsFactory} from "./declarations.documents.columns";
import {DeclarationsDocumentEditModal} from "./modal/edit/declaration.document.edit.modal";
import {DeclarationsDocument} from "../../../models/declarations/declarations.documents";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const DeclarationsDocumentsList: React.FC = () => {
    const t = useTranslate();

    const columns = useMemo(() => columnsFactory(t), []);
    const handler = useMemo(() => new SmartTableDataHandler(request => declarationsDocumentsService.getAll(request)), []);

    const [modalShown, setModalShown] = useState<boolean>(false);
    const [modalItem, setModalItem] = useState<DeclarationsDocument | null>(null);

    const openModal = (item: DeclarationsDocument | null) => {
        setModalShown(true);
        setModalItem(item);
    }

    const closeModal = async () => {
        setModalShown(false);
        setModalItem(null);
        await handler.reloadItemsWithLastRequest();
    }

    const remove = async (item: DeclarationsDocument) => {
        await declarationsDocumentsService.remove(item.id);
        await handler.reloadItemsWithLastRequest();
    }

    return (
        <Space direction={"vertical"} size={[10, 10]}>
            <Button
                type={"primary"}
                onClick={() => openModal(null)}
                icon={<FontAwesomeIcon icon={["fas", "plus"]} />}
            >
                {t('CREATE')}
            </Button>
            <SmartTable
                columns={columns}
                handler={handler}
                actions={[
                    {
                        icon: 'edit',
                        title: t('EDIT'),
                        onClick: openModal
                    },
                    {
                        icon: 'trash',
                        title: t('REMOVE'),
                        onClick: remove
                    }
                ]}
            />
            {modalShown ? (
                <DeclarationsDocumentEditModal item={modalItem} onClose={closeModal} />
            ) : null}
        </Space>
    );
};

